import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  /** `on-dark` uses the dark-background mark. */
  variant?: 'on-light' | 'on-dark' | 'icon' | 'wordmark';
}

const ICON_SIZES = {
  sm: 'h-11 w-11',
  md: 'h-14 w-14',
  lg: 'h-20 w-20',
  xl: 'h-24 w-24',
};

const Logo: React.FC<LogoProps> = ({ size = 'md', className = '', variant = 'on-light' }) => {
  const onDark = variant === 'on-dark';
  const file = onDark ? 'security-guardian-logo-dark-bg.png' : 'security-guardian-logo.png';
  const src = `${process.env.PUBLIC_URL}/${file}`;

  return (
    <img
      src={src}
      alt="Security Guardian"
      className={`${ICON_SIZES[size]} object-contain ${className}`.trim()}
    />
  );
};

export default Logo;
